import reducer from './reducers';

export { default as dataGovSagas } from './sagas';
export { default as dataGovActions } from './actions';

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/data-gov/index.js